import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Button } from './ui/Button';
export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past the hero section (approx 600px)
      // Hide when reaching the bottom CTA section
      const scrollY = window.scrollY;
      const ctaSection = document.getElementById('cta-section');
      let hideAtBottom = false;
      if (ctaSection) {
        const rect = ctaSection.getBoundingClientRect();
        hideAtBottom = rect.top < window.innerHeight;
      }
      if (scrollY > 600 && !hideAtBottom) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-160">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.3
    }} className="fixed bottom-0 left-0 right-0 p-4 bg-white/90 backdrop-blur-md border-t border-gray-200 shadow-[0_-10px_20px_rgba(0,0,0,0.05)] z-50 md:hidden" data-id="element-161">
          <div className="flex items-center justify-between gap-4 max-w-md mx-auto" data-id="element-162">
            <div className="flex flex-col" data-id="element-163">
              <span className="text-sm text-[#6B6560]" data-id="element-164">Protocolo 50+</span>
              <span className="font-bold text-[#2D2A26]" data-id="element-165">6.36€</span>
            </div>
            <Button className="py-3 px-6 text-sm flex-1" data-id="element-166">
              QUIERO MI PROTOCOLO
            </Button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}